import { axiosInstance as request } from '@api/rest.service'

const api = '/vendor-invoices'

/**
 * @description GET /vendor-invoices
 * @returns {AxiosPromise<any>}
 */
export const GET_VENDOR_INVOICES = () => request.get(api)

/**
 * @description GET /vendor-invoices/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_VENDOR_INVOICE = id => request.get(`${api}/${id}`)

/**
 * @description PATCH /vendor-invoices/{id}
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_VENDOR_INVOICE = (id, payload) => request.patch(`${api}/${id}`, payload)

/**
 * Special case for updating the file
 * @description POST /vendor-invoices/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPLOAD_INVOICE_FILE = (id, formData) => {
  formData.append('_method', 'PATCH')

  return request.post(`${api}/${id}`, formData)
}
